import { render, staticRenderFns } from "./Badge19.vue?vue&type=template&id=1a4441f1&scoped=true"
import script from "./Badge19.vue?vue&type=script&lang=js"
export * from "./Badge19.vue?vue&type=script&lang=js"
import style0 from "./Badge19.vue?vue&type=style&index=0&id=1a4441f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4441f1",
  null
  
)

export default component.exports